import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "@fontsource/poppins";  
import "@fontsource/poppins/400.css"; 
import "@fontsource/poppins/400-italic.css";  
import { Provider } from 'react-redux';
import Store from './Store';
import { ThemeProvider } from './Theme/ThemeContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>
  // <Provider store={Store} >
  //   <App />
  // </Provider>
  // <ThemeProvider>
  //   <div>
  //   <App/>

  //   </div>
  // </ThemeProvider>

  <Provider store={Store}>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </Provider>,
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
